import { FiBarChart2, FiBookOpen, FiBriefcase, FiClipboard, FiDollarSign, FiFileText, FiGrid, FiHome, FiLayers, FiPieChart, FiPlusSquare, FiUpload, FiUser } from 'react-icons/fi';

import Dashboard from './pages/dashboard/Dashboard';
import ExcelPaste from './excel-paste/ExcelPaste';
import CapitalAssetsPage from './capital-assets/CapitalAssetsPage';
import DeliveryTradesPage from './delivery-trades/DeliveryTradesPage';
import IncomeList from './income/list-income/IncomeList';
import AddIncome from './income/add-income/AddIncome';
import AssetList from './asset/list-assets/AssetList';
import AssetForm from './asset/add-assets/AddAssetForm';
import ProfitLossAccount from './profit-loss-account/ProfitLossAccount';
import BalanceSheet from './balance-sheet/BalanceSheet';
import TaxComputation from './tax-computation/TaxComputation';
import AddExpense from './expenses/add-expense/AddExpenses';
import ExpenseList from './expenses/expense-list/ExpenseList';
import CapitalGain from './capital-gain/CapitalGain';
import ProfilePage from './pages/ProfilePage';
import ConsolidatedReports from './consolidated-reports/ConsolidatedReports';
import CombinedProfitLoss from './combined-reports/CombinedProfitLoss';
import CombinedBalanceSheet from './combined-reports/CombinedBalanceSheet';
import CombinedCapitalGains from './combined-reports/CombinedCapitalGains';
import CombinedTaxComputation from './combined-reports/CombinedTaxComputation';

export const protectedRoutes = [
  {
    path: '/dashboard',
    label: 'Dashboard',
    section: 'Overview',
    description: 'See headline totals and the current work queue for the selected client and year.',
    icon: FiHome,
    component: Dashboard,
    showInNav: true,
    showInQuickActions: false,
    showInReports: false,
  },
  {
    path: '/excel',
    label: 'Import Data',
    section: 'Import & Review',
    description: 'Paste broker or transaction exports before posting them into the system.',
    icon: FiUpload,
    component: ExcelPaste,
    showInNav: true,
    showInQuickActions: true,
    showInReports: false,
  },
  {
    path: '/delivery-trades',
    label: 'Delivery Trades',
    section: 'Import & Review',
    description: 'Classify delivery trades and complete pending capital-gain review work.',
    icon: FiLayers,
    component: DeliveryTradesPage,
    showInNav: true,
    showInQuickActions: true,
    showInReports: false,
  },
  {
    path: '/capital-assets',
    label: 'Capital Assets',
    section: 'Accounting',
    description: 'Maintain capital asset and equity mutual fund transaction details.',
    icon: FiBriefcase,
    component: CapitalAssetsPage,
    showInNav: true,
    showInQuickActions: true,
    showInReports: false,
  },
  {
    path: '/asset-list',
    label: 'Asset Register',
    section: 'Accounting',
    description: 'Review and update the asset master used by depreciation and statements.',
    icon: FiBookOpen,
    component: AssetList,
    showInNav: true,
    showInQuickActions: false,
    showInReports: false,
  },
  {
    path: '/asset',
    label: 'Add Asset',
    section: 'Accounting',
    description: 'Create a new asset master record for depreciation and reporting.',
    icon: FiPlusSquare,
    component: AssetForm,
    showInNav: false,
    showInQuickActions: true,
    showInReports: false,
  },
  {
    path: '/list-income',
    label: 'Income Register',
    section: 'Accounting',
    description: 'Maintain manual income entries that flow into tax computation.',
    icon: FiDollarSign,
    component: IncomeList,
    showInNav: true,
    showInQuickActions: false,
    showInReports: false,
  },
  {
    path: '/add-income',
    label: 'Add Income',
    section: 'Accounting',
    description: 'Add a new income line with the appropriate tax-head classification.',
    icon: FiPlusSquare,
    component: AddIncome,
    showInNav: false,
    showInQuickActions: true,
    showInReports: false,
  },
  {
    path: '/list-expense',
    label: 'Expense Register',
    section: 'Accounting',
    description: 'Review and edit expenses that feed the trading and reporting views.',
    icon: FiFileText,
    component: ExpenseList,
    showInNav: true,
    showInQuickActions: false,
    showInReports: false,
  },
  {
    path: '/add-expense',
    label: 'Add Expense',
    section: 'Accounting',
    description: 'Capture a new expense entry for the selected client and year.',
    icon: FiPlusSquare,
    component: AddExpense,
    showInNav: false,
    showInQuickActions: true,
    showInReports: false,
  },
  {
    path: '/profit-loss',
    label: 'Profit & Loss',
    section: 'Reports',
    description: 'Review the income and expense statement for the selected period.',
    icon: FiBarChart2,
    component: ProfitLossAccount,
    showInNav: true,
    showInQuickActions: false,
    showInReports: true,
  },
  {
    path: '/balance-sheet',
    label: 'Balance Sheet',
    section: 'Reports',
    description: 'Inspect assets, liabilities, and closing balances in one statement.',
    icon: FiPieChart,
    component: BalanceSheet,
    showInNav: true,
    showInQuickActions: false,
    showInReports: true,
  },
  {
    path: '/capital-gain',
    label: 'Capital Gains',
    section: 'Reports',
    description: 'Review detailed STCG and LTCG schedules and period buckets.',
    icon: FiBriefcase,
    component: CapitalGain,
    showInNav: true,
    showInQuickActions: false,
    showInReports: true,
  },
  {
    path: '/tax-computation',
    label: 'Tax Computation',
    section: 'Reports',
    description: 'Open the tax working summary and depreciation schedule.',
    icon: FiClipboard,
    component: TaxComputation,
    showInNav: true,
    showInQuickActions: true,
    showInReports: true,
  },
  {
    path: '/profile',
    label: 'Profile',
    section: 'Workspace',
    description: 'Manage user profile, client access, time zone, and password.',
    icon: FiUser,
    component: ProfilePage,
    showInNav: true,
    showInQuickActions: false,
    showInReports: false,
  },
  {
    path: '/consolidated-reports',
    label: 'Combined Overview',
    section: 'Combined Reports',
    description: 'Scan P&L, capital gains, balance sheet, and tax computation in one cross-client reporting cockpit.',
    icon: FiGrid,
    component: ConsolidatedReports,
    showInNav: true,
    showInQuickActions: true,
    showInReports: false,
  },
  {
    path: '/combined-profit-loss',
    label: 'Combined P&L',
    section: 'Combined Reports',
    description: 'Aggregate the profit and loss statement across all or selected client IDs.',
    icon: FiBarChart2,
    component: CombinedProfitLoss,
    showInNav: true,
    showInQuickActions: false,
    showInReports: false,
  },
  {
    path: '/combined-balance-sheet',
    label: 'Combined Balance Sheet',
    section: 'Combined Reports',
    description: 'Review the combined closing statement for the chosen client scope.',
    icon: FiPieChart,
    component: CombinedBalanceSheet,
    showInNav: true,
    showInQuickActions: false,
    showInReports: false,
  },
  {
    path: '/combined-capital-gains',
    label: 'Combined Capital Gains',
    section: 'Combined Reports',
    description: 'Inspect capital-gain schedules across all or selected client IDs.',
    icon: FiBriefcase,
    component: CombinedCapitalGains,
    showInNav: true,
    showInQuickActions: false,
    showInReports: false,
  },
  {
    path: '/combined-tax-computation',
    label: 'Combined Tax Computation',
    section: 'Combined Reports',
    description: 'Open the aggregated tax working summary and depreciation schedules.',
    icon: FiClipboard,
    component: CombinedTaxComputation,
    showInNav: true,
    showInQuickActions: false,
    showInReports: false,
  },
];

const sectionOrder = ['Overview', 'Import & Review', 'Accounting', 'Reports', 'Combined Reports', 'Workspace'];

export const navigationSections = sectionOrder.map((section) => ({
  label: section,
  routes: protectedRoutes.filter((route) => route.showInNav && route.section === section),
})).filter((section) => section.routes.length > 0);

export const quickActionRoutes = protectedRoutes.filter((route) => route.showInQuickActions);

export const reportRoutes = protectedRoutes.filter((route) => route.showInReports);

export const findRouteByPath = (pathname) => protectedRoutes.find((route) => route.path === pathname);